import envConfig from 'configs/envConfig';
import { assets as homiqAssets } from './homiq/assets';
import { assets as instaviewAssets } from './instaview/assets';
import { assets as lunaAssets } from './luna/assets';
import {
  TAllPartnerAssets,
  TCommonPartnerAssets,
  TPartnerAssets
} from './types';

const partnerAssetsMap = {
  instaview: instaviewAssets,
  luna: lunaAssets,
  homiq: homiqAssets,
  default: instaviewAssets
};

const PARTNER = envConfig('partner') || 'instaview';

// const baseUrl = `${process.env.REACT_APP_B2_BUCKET_URL}/${PARTNER}`;

const commonUrl = `${envConfig('b2BucketUrl')}/common`;

export const commonAssets: TCommonPartnerAssets = {
  support24Icon: `${commonUrl}/24-support.svg`,
  invoiceIcon: `${commonUrl}/Invoice.svg`,
  aiFalseAlertIcon: `${commonUrl}/ai_false_alert.svg`,
  alarmIcon: `${commonUrl}/alarm.svg`,
  amexCard: `${commonUrl}/amex.svg`,
  camera1Icon: `${commonUrl}/cameraIcon.png`,
  cameraSnapshotPlaceholderImg: `${commonUrl}/cameraSnapshotPlaceholder.png`,
  camera2Icon: `${commonUrl}/camera_icon.svg`,
  cloudAddIcon: `${commonUrl}/cloud-add.svg`,
  cloudStorageIcon: `${commonUrl}/cloud-storage.svg`,
  contextualAIIcon: `${commonUrl}/contextualAI.svg`,
  creditRegularCard: `${commonUrl}/credit-card-regular.svg`,
  defaultScreenshotImg: `${commonUrl}/defaultScreenshot.png`,
  discoverCard: `${commonUrl}/discover.png`,
  drawerMenuIcon: `${commonUrl}/drawerMenuIcon.svg`,
  eyeIcon: `${commonUrl}/eye.svg`,
  infoIcon: `${commonUrl}/infoIcon.svg`,
  masterCard: `${commonUrl}/mastercard.svg`,
  monitoringIcon: `${commonUrl}/monitoringIcon.svg`,
  monitoringCertificateIcon: `${commonUrl}/monitoring_certificate.svg`,
  notificationBingIcon: `${commonUrl}/notification-bing.svg`,
  peopleIcon: `${commonUrl}/people_icon.svg`,
  professionalMonitorEyeIcon: `${commonUrl}/professional_monitor_eye.svg`,
  searchIcon: `${commonUrl}/searchIcon.svg`,
  videoCameraIcon: `${commonUrl}/videoCamera.svg`,
  videoCamera10Icon: `${commonUrl}/video_10_camera.svg`,
  videoCamera1Icon: `${commonUrl}/video_1_camera.svg`,
  visaCard: `${commonUrl}/visa.svg`,
  defaultIcon: `${commonUrl}/star.svg`
};

const getPartnerAssetConfig = (): TPartnerAssets => {
  return (
    partnerAssetsMap[PARTNER as keyof typeof partnerAssetsMap] ||
    partnerAssetsMap.default
  );
};

const assetConfig = getPartnerAssetConfig();

export const partnerSpecificAssets = Object.entries(assetConfig).reduce(
  (acc, [key, filename]) => {
    acc[key as keyof TPartnerAssets] = filename;
    return acc;
  },
  {} as Record<keyof TPartnerAssets, string>
);

export const partnerAssets: TAllPartnerAssets = {
  ...partnerSpecificAssets,
  ...commonAssets
};
